import { render, staticRenderFns } from "./classical-admin-training-evaluation.vue?vue&type=template&id=2ef60d46"
import script from "./classical-admin-training-evaluation.vue?vue&type=script&lang=js"
export * from "./classical-admin-training-evaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports